/**
 * Mixin à utiliser sur les dialog qui sont utilisés avec $q.dialog({ component: YourDialog })
 */
export default {
  props: {
    title: String
  },
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    onOk () {
      this.$emit('ok', this)
    },
    show () {
      this.showDialog = true
    },
    hide () {
      this.showDialog = false
    }
  }
}
